import React from "react";
import { PureComponent } from "react";
import { decimalsRound } from "../../services/utils";

import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer
} from "recharts";
import Teams from "../../api/Teams";
import { GraphText } from "./styles";

class DashboardLineChart extends PureComponent {
  getTooltipName = key => {
    switch (key) {
      case "wv":
        return "Team";
      case "hvw":
        return "Highest";
      case "mvw":
        return "Medium";
      case "avw":
        return "Average";
      default:
        return null;
    }
  };

  render() {
    const { teamGradings: rawTeamGradings, round_number } = this.props;

    const textColor = "hsla(213, 100%, 12%, 0.6)";
    const lineColor = "hsla(213, 100%, 12%, 0.94)";

    const currentTeam = Teams.currentTeam();

    const teamGradings = rawTeamGradings.results;
    const filteredTeamGrading = teamGradings.filter(
      item => (
        Number(item.round_number) <= Number(round_number) &&
        Number(item.team) === Number(currentTeam.id)
      )
    );

    const data = filteredTeamGrading.map(item => ({
      name: `Year ${item.round_number}`,
      wv: decimalsRound(item.weighted_value * 100, 2),
      hvw: decimalsRound(item.highest_weighted_value * 100, 2),
      mvw: decimalsRound(item.median_weighted_value * 100, 2),
      avw: decimalsRound(item.average_weighted_value * 100, 2)
    }));
    if (data.length === 0) {
      data.push({
        name: `Year ${round_number}`,
        wv: 0,
        hwv: 0,
        mvw: 0,
        avw: 0,
      });
    }

    const teamColor = Teams.currentTeamColorLevel3();

    return (
      <ResponsiveContainer width="100%" height={160}>
        <LineChart
          width={340}
          height={160}
          data={data}
          margin={{
            top: 5,
            right: 10,
            left: 10,
            bottom: 0
          }}
        >
          <Tooltip
            formatter={(value, name, props) => [
              `${value}%`,
              this.getTooltipName(name)
            ]}
            allowEscapeViewBox={{ x: true, y: true }}
          />
          <XAxis
            dataKey="name"
            padding={{ left: 20, right: 20 }}
            axisLine={{ stroke: lineColor }}
            style={{ ...GraphText, fill: textColor }}
            tickLine={{ stroke: lineColor }}
          />
          <YAxis
            tickFormatter={value => `${value}%`}
            tickCount={5}
            interval={0}
            width={30}
            axisLine={{ stroke: lineColor }}
            style={{ ...GraphText, fill: textColor }}
            tickLine={{ stroke: lineColor }}
          />
          <Line
            type="monotone"
            dataKey="wv"
            stroke={teamColor}
            strokeWidth={1}
            dot={false}
          />
          <Line
            type="monotone"
            dataKey="hvw"
            stroke="hsla(213, 100%, 12%, 0.8)"
            strokeWidth={1}
            dot={false}
          />
          <Line
            type="monotone"
            dataKey="mvw"
            stroke="hsla(213, 100%, 12%, 0.45)"
            strokeWidth={1}
            dot={false}
          />
          <Line
            type="monotone"
            dataKey="avw"
            stroke="hsla(213, 100%, 12%, 0.2)"
            strokeWidth={1}
            dot={false}
          />
        </LineChart>
      </ResponsiveContainer>
    );
  }
}

export default DashboardLineChart;



// WEBPACK FOOTER //
// ./src/components/dashboard/DashboardLineChart.js